import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAttributeListAtom } from 'hooks/form/filter';
import { useChangedFilterList } from 'hooks/form/useChangedFilterList';
import { QaIdentifier } from 'hooks/useQa';

import { diffSets } from 'utility/Toggle/toggleValueInSet';

import { Attribute } from 'proto/Accommodation/Attributes';

import Segment from '../Segment';
import { MetaValue } from '../Segment/__hooks/useDisabledStatus';

import Attributes from './__partials/Attributes';

interface AmenitiesAndServiceProps {
    attributeListArray: Attribute[];
    headlineKey: string;
    disableWhen?: MetaValue;
}

const AmenitiesAndService = ({
    attributeListArray,
    headlineKey,
    disableWhen = MetaValue.Never,
}: AmenitiesAndServiceProps) => {
    const { t } = useTranslation();
    const [attributeList, setAttributeList] = useAttributeListAtom();
    const filterList = [...Attributes(attributeListArray, disableWhen)];

    const { onClear } = useChangedFilterList();

    if (!filterList.length) {
        return null;
    }

    return (
        <Segment
            headline={{ text: t(headlineKey) }}
            qaIdentifier={
                QaIdentifier.Search_Filter_Section_AmenitiesAndService
            }
            onDelete={() => {
                onClear(() =>
                    attributeListArray.filter((value) =>
                        attributeList.has(value)
                    )
                );
                setAttributeList((current) =>
                    diffSets(current, new Set(attributeListArray))
                );
            }}
            withDeleteLink
            filterList={filterList}
        />
    );
};

export default AmenitiesAndService;
